// config.js

// This value is shipped to browsers and is therefore a public client identifier,
// never a secret. Authorization continues to be enforced by backend JWT roles.
export const apiKey = process.env.REACT_APP_API_KEY || '';
